<nav class="main-header" >
      <div class="logo-container">
        <a href="/" class="brand-admin"><i class="fa fa-cube"></i><span>CRM</span>STACK</a>
      </div>
      <div class="header-content">
        <div class="row">

              <a href="/ajuda" target="_blank" class="header-help">
                <i class="fa fa-question-circle-o nav-icon ajuda"></i>
                <span>Ajuda</span>
              </a>


        </div>
      </div>
      <div class="col-md-2 pull-right text-right" style="top:15px;position: absolute;right: 0;">
        <div class="nav-item text-azul text-right pull-right" (click)="exibirNotificacoes($event)" >
          <a class="nav-link text-azul" role="button">

            <i class="fa fa-bell-o text-azul nav-icon notificacao"></i>
            <span *ngIf="notificacoes.length > 0" class="badge badge-warning  numero-notificacoes">{{this.notificacoes.length}}</span>


          </a>
        </div>
        <div (click)="$event.stopPropagation()" *ngIf="showNotificacao"
             class="dropdown-menu dropdown-menu-end notification-dropdown show">
          <div class="topnav-dropdown-header">
            <h4 class="notification-title">{{this.notificacoes.length}} Notificações</h4>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li *ngFor="let notificacao of notificacoes" class="notification-message">
                <a href="#">
                  <div class="media d-flex">
                    <span class="avatar flex-shrink-0">
                      <i class="fa fa-bell-o"></i>
                      <span class="badge badge-info rounded-pill"></span>
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="noti-details">{{notificacao.titulo}}</p>
                      <p class="noti-sub-details" [innerHTML]="notificacao.texto"></p>
                      <p class="noti-time">{{ notificacao.datacadastro | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <a href="#" class="view-link" (click)="verTodasNotificacoes($event)">Ver todas</a>
            <a href="javascript:void(0);" class="clear-link" (click)="limparNotificacoes()">Limpar todas</a>
          </div>
        </div>
      </div>
</nav>
